/**
 * JWT decoding helpers.
 *
 * JWTs are encoded with base64url (RFC 7515), not standard base64. The browser
 * `atob` only handles standard base64 and either throws `InvalidCharacterError`
 * on `-`/`_` characters or returns garbage when padding has been stripped.
 *
 * `base64UrlDecode` performs the URL-safe -> standard conversion and re-adds
 * any missing padding before delegating to `atob`. `getTokenExpiry` parses the
 * payload to extract the `exp` claim for proactive refresh scheduling.
 */

export function base64UrlDecode(input: string): string {
  let s = input.replace(/-/g, "+").replace(/_/g, "/");
  const pad = s.length % 4;
  if (pad) {
    s += "=".repeat(4 - pad);
  }
  return atob(s);
}

/** Decode a JWT and return the exp claim (Unix timestamp), or null on failure. */
export function getTokenExpiry(token: string): number | null {
  try {
    const parts = token.split(".");
    if (parts.length !== 3) {
      return null;
    }
    const payload = JSON.parse(base64UrlDecode(parts[1])) as Record<string, unknown>;
    return typeof payload.exp === "number" ? payload.exp : null;
  } catch {
    return null;
  }
}
